/**
 * Biboja header customizations.
 *
 * 1. Replaces Dawn's search icon with the text "SEARCH".
 * 2. Keeps the "BAG (n)" count in the header in sync after AJAX cart
 *    actions (add to cart, cart drawer updates).
 *
 * The cart link itself is rendered by sections/header.liquid as
 * BAG (<span id="biboja-cart-count">…</span>); this script only updates
 * the number. The search summary keeps its aria-label from
 * snippets/header-search.liquid, so the visible text swap is purely
 * presentational.
 */
document.addEventListener('DOMContentLoaded', function () {
  var searchButton = document.querySelector('.header__icon--search');
  if (searchButton) {
    var searchText = document.createElement('span');
    searchText.className = 'custom-search-text';
    searchText.textContent = 'SEARCH';
    searchButton.replaceChildren(searchText);
  }

  var cartLink = document.getElementById('cart-icon-bubble');
  if (!cartLink) return;

  // Announce count changes to screen readers as one phrase, e.g. "BAG (2)".
  cartLink.setAttribute('aria-live', 'polite');
  cartLink.setAttribute('aria-atomic', 'true');

  function updateCartCount(count) {
    var countEl = document.getElementById('biboja-cart-count');
    if (!countEl) {
      countEl = document.createElement('span');
      countEl.id = 'biboja-cart-count';
      cartLink.replaceChildren('BAG (', countEl, ')');
    }
    countEl.textContent = count;
  }

  // Some cart flows dispatch 'cart:updated' after AJAX actions.
  document.addEventListener('cart:updated', function (event) {
    var count =
      event.detail && event.detail.cart ? event.detail.cart.item_count : 0;
    updateCartCount(count);
  });

  // Fallback: if the cart link's contents get re-rendered, re-fetch the
  // real count from /cart.js (debounced).
  var debounceTimer;
  var observer = new MutationObserver(function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      fetch('/cart.js')
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          updateCartCount(data.item_count);
        });
    }, 500);
  });
  observer.observe(cartLink, { childList: true });
});
